const LOAD_CANDIDATE_TIMEZONE           = 'LOAD_CANDIDATE_TIMEZONE'
const LOAD_CANDIDATE_TIMEZONE_SUCCESS   = 'LOAD_CANDIDATE_TIMEZONE_SUCCESS'
const LOAD_CANDIDATE_TIMEZONE_FAILED    = 'LOAD_CANDIDATE_TIMEZONE_FAILED'
const UNMOUNT_CANDIDATE_TIMEZONE        = 'UNMOUNT_CANDIDATE_TIMEZONE'
const initialState = {
  loading: true,
  data: null,
  message: null,
}
const candidateTimezoneReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_CANDIDATE_TIMEZONE:
      return {
        ...state,
        loading: true,
        data: null,
      }
    case LOAD_CANDIDATE_TIMEZONE_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_CANDIDATE_TIMEZONE_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_CANDIDATE_TIMEZONE:
      return { 
        ...state, 
        loading: true,
        data: null,
      }
    default:
      return state
  }
}
export default candidateTimezoneReducer;